import { render, staticRenderFns } from "./VvSingleTip.vue?vue&type=template&id=57831621&scoped=true&"
import script from "./VvSingleTip.vue?vue&type=script&lang=js&"
export * from "./VvSingleTip.vue?vue&type=script&lang=js&"
import style0 from "./VvSingleTip.vue?vue&type=style&index=0&id=57831621&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57831621",
  null
  
)

export default component.exports